export default [{
		path: '/',
		redirect: '/personal/index',
	},
	{
		path: '/personal',
		redirect: '/personal/index',
	},
	{
		path: '/team',
		redirect: '/team/index',
	},
	{
		path: '*',
		component: resolve => require(['@/common/components/404'], resolve),
		meta: {
			title: '404'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/common.js